// Ses Ayarları Bileşeni
import React, { useState } from 'react';
import { Volume2, VolumeX, Volume1 } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function SoundSettings({ className }) {
  // LocalStorage'dan başlangıç değerlerini al
  const getInitialSoundEnabled = () => {
    const saved = localStorage.getItem('kariyerSoundEnabled');
    return saved !== null ? saved === 'true' : true;
  };
  
  const getInitialVolume = () => {
    const saved = localStorage.getItem('kariyerSoundVolume');
    return saved !== null ? parseFloat(saved) : 0.5;
  };
  
  const [soundEnabled, setSoundEnabled] = useState(getInitialSoundEnabled);
  const [volume, setVolume] = useState(getInitialVolume);
  const [showSlider, setShowSlider] = useState(false);
  
  const toggleSound = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    localStorage.setItem('kariyerSoundEnabled', newValue.toString());
  };
  
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    localStorage.setItem('kariyerSoundVolume', newVolume.toString());
  };
  
  const VolumeIcon = soundEnabled 
    ? (volume > 0.5 ? Volume2 : Volume1) 
    : VolumeX;
  
  return (
    <div className={cn("relative inline-flex items-center", className)}>
      <button
        onClick={toggleSound}
        onMouseEnter={() => setShowSlider(true)}
        onMouseLeave={() => setShowSlider(false)}
        className={cn(
          "p-2 rounded-full transition-all duration-200",
          soundEnabled 
            ? "bg-blue-100 text-blue-600 hover:bg-blue-200" 
            : "bg-gray-100 text-gray-400 hover:bg-gray-200"
        )}
        title={soundEnabled ? 'Sesi Kapat' : 'Sesi Aç'}
      >
        <VolumeIcon className="w-5 h-5" />
      </button>
      
      {/* Ses Seviyesi Slider */}
      {showSlider && soundEnabled && (
        <div 
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 p-3 bg-white rounded-lg shadow-lg border z-50"
          onMouseEnter={() => setShowSlider(true)}
          onMouseLeave={() => setShowSlider(false)}
        >
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
            className="w-24 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
          />
          <div className="text-xs text-center text-gray-500 mt-1">
            {Math.round(volume * 100)}%
          </div>
        </div>
      )}
    </div>
  );
}
